import { useMemo } from "react";

import { css } from "@emotion/react";
import { TEXT_COLOR } from "@hl/base-components/lib/theme/colors";
import { Text } from "@mantine/core";

import { SectionType } from "apollo/graphql.generated";

import PageSectionView from "../../pages/PageSectionView";

import PreviewContentFooter from "./PreviewContentFooter";

interface PreviewUnlockedProps {
  content: string;
  showPlaceHolder: boolean;
}

export const PreviewUnlocked = ({
  content,
  showPlaceHolder,
}: PreviewUnlockedProps) => {
  const section = useMemo(
    () => ({
      type: SectionType.EditorData,
      id: "main",
      content: {
        editorContent: {
          state: content,
        },
      },
    }),
    [content]
  );

  return (
    <div
      css={css`
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-content: space-between;
      `}
    >
      {showPlaceHolder ? (
        <div
          css={css`
            height: 100%;
            display: flex;
            align-items: center;
            padding: 10px 0px;
            line-height: 100%;
          `}
        >
          <Text color={TEXT_COLOR.SECONDARY} align="center">
            Add content to see a preview of your unlocked page
          </Text>
        </div>
      ) : (
        <div
          css={css`
            padding: 32px 16px;
            height: 100%;
          `}
        >
          <PageSectionView pageSection={section} />
        </div>
      )}
      <PreviewContentFooter />
    </div>
  );
};
